// extracted by mini-css-extract-plugin
module.exports = {"similarTemplates":"similar-templates_similarTemplates__iqJIc","templatesGrid":"similar-templates_templatesGrid__jDEEk","dots":"similar-templates_dots__72i8D"};